import _cloneDeep from 'lodash-es/cloneDeep.js'

// ===================================
// Constants
// ===================================

const CACHE_KEY = 'mygwf_reportCharts'

const CHART_DATA = {
  battery1Status: {title: 'Battery1 Status'},
  battery2Status: {title: 'Battery2 Status'},
  batteryLifetime: {title: 'Battery Lifetime'},
  batteryVoltage: {title: 'Battery Voltage'},
  deltaVolume: {title: 'Delta Volume'},
  flow: {title: 'Flow'},
  level1: {title: 'Level 1'},
  meanVelocity: {title: 'Mean Velocity'},
  sensorStatus: {title: 'Sensor Status'},
  spreadFactor: {title: 'Spread Factor'},
  totalVolume: {title: 'Total Volume'},
}

const DEFAULT_SETTINGS = {
  afm: [
    {c: 'totalVolume', v: true, t: 'line'},
    {c: 'deltaVolume', v: true, t: 'bar'},
    {c: 'flow', v: true, t: 'line'},
    {c: 'level1', v: true, t: 'line'},
    {c: 'meanVelocity', v: true, t: 'line'},
    {c: 'sensorStatus', v: true, t: 'line'},
    {c: 'batteryVoltage', v: true, t: 'line'},
    {c: 'battery1Status', v: true, t: 'line'},
    {c: 'battery2Status', v: true, t: 'line'},
  ],
  rcmlrwotaa: [
    {c: 'totalVolume', v: true, t: 'line'},
    {c: 'deltaVolume', v: true, t: 'bar'},
    {c: 'spreadFactor', v: true, t: 'line'},
    {c: 'batteryLifetime', v: true, t: 'line'},
  ],
}

// ===================================
// Module
// ===================================

const state = {
  chartData: CHART_DATA,
  defaultSettings: DEFAULT_SETTINGS,
  currentSettings: loadCurrentSettings(),
}

const getters = {
  getChartData(state) {
    return _cloneDeep(state.chartData)
  },

  getDefaultSettings: state => meter_type => {
    return _cloneDeep(state.defaultSettings[meter_type.toLowerCase()])
  },

  getDefaultSettingsRaw(state) {
    return _cloneDeep(state.defaultSettings)
  },

  getCurrentSettings: state => meter_type => {
    return _cloneDeep(state.currentSettings[meter_type.toLowerCase()])
  },

  getCurrentSettingsRaw(state) {
    return _cloneDeep(state.currentSettings)
  },
}

const mutations = {
  SET_SETTINGS(state, settings) {
    settings = _cloneDeep(settings)
    state.currentSettings = settings
    localStorage.setItem(CACHE_KEY, JSON.stringify(settings))
  },

  RESET_SETTINGS(state) {
    const settings = _cloneDeep(state.defaultSettings)
    state.currentSettings = settings
    localStorage.setItem(CACHE_KEY, JSON.stringify(settings))
  },
}

const actions = {
  saveSettings({commit, getters}, {meterType, settings}) {
    if (!meterType || !settings) {
      return
    }
    const newSettings = getters.getCurrentSettingsRaw
    newSettings[meterType.toLowerCase()] = settings
    commit('SET_SETTINGS', newSettings)
  },

  resetToDefaultSettings({commit, getters}, meterType = null) {
    // Reset all meter types
    if (!meterType) {
      commit('RESET_SETTINGS')
    }

    // Reset specific meter type
    const defaultSettings = getters.getDefaultSettingsRaw
    const currentSettings = getters.getCurrentSettingsRaw
    const newSettings = {
      ...currentSettings,
      [meterType]: defaultSettings[meterType],
    }
    commit('SET_SETTINGS', newSettings)
  },
}

export default {namespaced: true, state, getters, mutations, actions}

// ===================================
// Helpers
// ===================================

function loadCurrentSettings() {
  const settings = localStorage.getItem(CACHE_KEY)
  return settings ? JSON.parse(settings) : DEFAULT_SETTINGS
}
